import { Button, Icon } from "@sellar-io/components";

export const SwitchCreditProviderButton = ({
  onSwitchClick,
  currentProvider,
}: {
  onSwitchClick: () => void;
  currentProvider: "two" | "hokodo";
}) => {
  if (currentProvider === "hokodo") {
    return (
      <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-zinc-300 bg-zinc-50 p-4">
        <div className="flex items-center gap-4">
          <Icon icon="SELLAR" className="shrink-0 text-[#b557f1]" size={1} />

          <div className="flex flex-col gap-1">
            <div className="text-base font-semibold text-zinc-800">
              You are viewing your previous Sellar Credit activity with Hokodo
            </div>
            <div className="text-base text-zinc-800">
              To see your current Sellar Credit orders and invoices with Two
              Inc, you can switch views using the button opposite
            </div>
          </div>
        </div>

        <Button
          color="secondary"
          className="font-semibold text-zinc-800"
          onClick={onSwitchClick}
        >
          <Icon size={1} icon="SWAP_VERTICAL" className="text-zinc-800" />
          Switch
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-zinc-300 bg-zinc-50 p-4">
      <div className="flex items-center gap-4">
        <Icon icon="SELLAR" className="shrink-0 text-[#b557f1]" size={1} />

        <div className="flex flex-col gap-1">
          <div className="text-base font-semibold text-zinc-800">
            Sellar Credit is now powered by Two Inc
          </div>
          <div className="text-base text-zinc-800">
            To see your previous Sellar Credit orders and invoices with Hokodo,
            you can switch views using the button opposite
          </div>
        </div>
      </div>

      <Button
        color="secondary"
        className="font-semibold text-zinc-800"
        onClick={onSwitchClick}
      >
        <Icon size={1} icon="SWAP_VERTICAL" className="text-zinc-800" />
        Switch
      </Button>
    </div>
  );
};
